__turbopack_context__.v({
  "gam-sandbox": "index-module-scss-module__WaMUPW__gam-sandbox",
  "gam-sandbox--overflow-h": "index-module-scss-module__WaMUPW__gam-sandbox--overflow-h",
  "gam-sandbox--with-placeholder": "index-module-scss-module__WaMUPW__gam-sandbox--with-placeholder",
});
